export default __webpack_public_path__ + "static/media/srisailamAboutTwo.452b9cb0.jpg";